import EventsCompo from 'csdd_components/EventsCompo';
import EventsHeader from 'csdd_components/EventsHeader';
import Footer from 'csdd_components/Footer';
import HomeNavBar from 'csdd_components/HomeNavBar';
import Newsletter from 'csdd_components/Newsletter';
import TopNavBar from 'csdd_components/TopNavBar';

const Events = () => {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <EventsHeader />
      <EventsCompo />
      <Newsletter />
      <Footer />
    </>
  );
};
export default Events;
